import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Alerts } from 'src/app/utils/alert';
import { TypeAlert } from 'src/app/shared/constants/enums.interface';
import { EnvconfigService } from 'src/app/core/service/envconfig.service';
import { GeneralService } from 'src/app/core/service/general/general.service';
import { first } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { SeguridadService } from 'src/app/core/service/seguridad/seguridad.service';

@Component({
  selector: 'app-retroalimentacion',
  templateUrl: './retroalimentacion.component.html',
  styleUrls: ['./retroalimentacion.component.css'],
  standalone: false
})
export class RetroalimentacionComponent {
  LoginSapForm!: FormGroup;
  ListaCalifacion : number[]  = [1,2,3,4,5,6,7,8,9,10];
  buttonColors: { [key: number]: boolean } = {};
  selectedButtonId : number =-1;
  intCantCaracteres : number = 0;
  strMensaje : string = '';
  nombreUsuario: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private alerts: Alerts,
    private environment: EnvconfigService,
    private generalService:GeneralService,
    public dialogRef: MatDialogRef<RetroalimentacionComponent>,
    private seguridadService: SeguridadService
  ) { }

  ngOnInit() {
    this.LoginSapForm = this.formBuilder.group({
      strcomentario: ['']
    });
    this.nombreUsuario = localStorage.getItem('NombreUsuario')??'';
    if(this.nombreUsuario !== ''){
       const nombresSeparados = this.nombreUsuario.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1));
      this.nombreUsuario = nombresSeparados[0];
    }
  }

  onButtonClick(id : number){
    this.selectedButtonId = id;
  }

  getButtonClass(id: number): any {
    const colorClass = id < 6 ? this.selectedButtonId === id ? 'selected_red': 'red' : id < 9 ? this.selectedButtonId === id ? 'selected_yellow': 'yellow' : this.selectedButtonId === id ? 'selected_green': 'green';
   return {
      [colorClass]: true
   };
  }


  isSelected(id: number): boolean {
    return this.selectedButtonId === id;
  }

  onChangeTxt(event:any){
    const textarea = event.target as HTMLTextAreaElement;
    const textareaValue = (event.target as HTMLTextAreaElement).value;
   
   this.intCantCaracteres = textareaValue.length;

    // Limita a 250 caracteres
    if (this.intCantCaracteres > 249) {
      textarea.value = textareaValue.substring(0, 249); // Trunca el texto a 250 caracteres
    }

  }

  Enviar(){
    this.strMensaje = '';
    if(this.ValidarPuntaje()){
      this.alerts.Notificacion(TypeAlert.Info, this.strMensaje, "Advertencia");
    }else{
      const request = this.prepareRequestObject();

      this.generalService.InsertarCalificacion(request)
      .pipe(
        first()
      )
      .subscribe({
        next: (res) => {
          this.handleResponse(res);

        },
        error: (error) => {
          this.alerts.Notificacion(TypeAlert.Error, `Ocurrió un error al registrar la calificación`, "Error");
          console.log(`${error}`);
        },
        complete: () => {
        }
      });
    }
  }

  ValidarPuntaje(): boolean{
    this.strMensaje = this.selectedButtonId < 0 ? 'No ha elegido Calificación' : '';
    return this.strMensaje ? true : false;
  }

  prepareRequestObject() {
    return {
      p_vcCodUser: this.seguridadService.getCodigoUsuario??'',
      p_intScore : this.selectedButtonId,
      p_vcFeedBack : this.LoginSapForm.get("strcomentario")?.value ?? ''  
    };
  }

  handleResponse(res : any){
    const esCorrecto = res.data;
    if(esCorrecto){
      this.alerts.Notificacion(TypeAlert.Success, 'Gracias por tu opinión. ¡Tu feedback nos ayuda a mejorar!', "Información");
      setTimeout(() => {
        this.dialogRef.close(false);
      }, 1500);
    }else{
      this.alerts.Notificacion(TypeAlert.Error, `Ocurrió un error al registrar la calificación`, "Error");
      console.log(`${res.message}`);
    }
  }

}
